import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { JwtService } from "./jwt.service";
import { JwtHelper, tokenNotExpired } from "angular2-jwt";
import { AuthService } from "./auth.service";
import { Http } from "@angular/http";

@Injectable()
export class AuthGuard implements CanActivate {
    private jwtHelper;
    private token = null;

    constructor(
        private router: Router,
        private authService: AuthService,
        private jwtService: JwtService,
        private http: Http
    ) {
        this.jwtHelper = new JwtHelper();
    }

    private setHeaders(): Headers {
        const headersConfig = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + localStorage.getItem('token')
        };
        return new Headers(headersConfig);
    }

    canActivate() {
        this.token = this.jwtService.getToken();

        try {
            if (this.token && !tokenNotExpired()) {

                this.authService.refreshToken();
            } else if (this.token) {

                return true;
            } else {

                this.router.navigateByUrl('/login');
                return false;
            }
        } catch (e) {
            
            this.router.navigate(['/login']);
            return false;
        }
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/auth-guard.service.ts